<script>
    export let name;
    export let status;
    export let keyPressed;
</script>

<button on:click={keyPressed} disabled="{status != 'enabled'}" class="{status}">{name}</button>
